/*
  ページ全体に「慣性スムーススクロール」を適用するための初期化スクリプト。
  ホイール／トラックパッド操作時に、スクロールがなめらかに減速しながら止まるようにする
  （サンプルサイト kiyasuku.com / jewelry.magnolia-white.com と同様の挙動）。
  実体のスクロール処理は Lenis ライブラリ（lenis.min.js）に任せている。
*/
(function () {
  var DEBUG_QUERY_PARAM = 'emissionScrollDebug';
  var DEBUG_STORAGE_KEY = 'emissionScrollDebug';
  var DEBUG_LOG_PREFIX = '[EmissionScrollDebug]';

  /*
    スクロールのカクつき調査用ロガー。
    URL に ?emissionScrollDebug=1 を付けた時だけ内部に計測を蓄積し、通常閲覧では何もしない。
    ?emissionScrollDebug=console の場合のみ、調査用に各イベントを逐次 console 出力する。
  */
  function initEmissionScrollDebug() {
    if (window.EmissionScrollDebug) {
      return window.EmissionScrollDebug;
    }

    var queryValue = null;

    try {
      queryValue = new URLSearchParams(window.location.search).get(DEBUG_QUERY_PARAM);
    } catch (error) {
      queryValue = null;
    }

    if (queryValue === '1' || queryValue === 'console') {
      try {
        window.localStorage.setItem(DEBUG_STORAGE_KEY, queryValue);
      } catch (error) {
        // localStorage が使えない環境でも、現在のページではデバッグを継続する
      }
    }

    if (queryValue === '0') {
      try {
        window.localStorage.removeItem(DEBUG_STORAGE_KEY);
      } catch (error) {
        // localStorage が使えない場合は無視する
      }
    }

    var isEnabled = queryValue === '1' || queryValue === 'console';
    var isConsoleEnabled = queryValue === 'console';

    if (!isEnabled) {
      try {
        var storedDebugValue = window.localStorage.getItem(DEBUG_STORAGE_KEY);
        isEnabled = storedDebugValue === '1' || storedDebugValue === 'console';
        isConsoleEnabled = storedDebugValue === 'console';
      } catch (error) {
        isEnabled = false;
      }
    }

    var events = [];

    var debug = {
      enabled: isEnabled,
      consoleEnabled: isConsoleEnabled,
      events: events,
      log: function (type, payload) {
        if (!isEnabled) {
          return;
        }

        var event = Object.assign(
          {
            type: type,
            t: Math.round(performance.now()),
            y: Math.round(window.scrollY || window.pageYOffset || 0),
            htmlClass: document.documentElement.className,
          },
          payload || {}
        );

        events.push(event);

        if (events.length > 500) {
          events.shift();
        }

        if (isConsoleEnabled) {
          console.log(DEBUG_LOG_PREFIX, event);
        }
      },
      dump: function () {
        console.log(DEBUG_LOG_PREFIX + ' dump', JSON.stringify(events, null, 2));
        return events;
      },
      text: function () {
        return JSON.stringify(events, null, 2);
      },
      copy: function () {
        var text = JSON.stringify(events, null, 2);

        if (typeof copy === 'function') {
          copy(text);
          console.log(DEBUG_LOG_PREFIX + ' copied with console copy()');
          return text;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text);
          console.log(DEBUG_LOG_PREFIX + ' copied with navigator.clipboard');
        } else {
          console.log(DEBUG_LOG_PREFIX + ' copy unavailable. Use window.EmissionScrollDebug.text().');
        }

        return text;
      },
      clear: function () {
        events.length = 0;
        console.log(DEBUG_LOG_PREFIX + ' cleared');
      },
    };

    window.EmissionScrollDebug = debug;
    window.__emissionScrollDebugEvents = events;

    if (isEnabled) {
      console.log(
        DEBUG_LOG_PREFIX,
        'enabled. Events are buffered. Use window.EmissionScrollDebug.copy() or .dump() after reproducing.'
      );
    }

    return debug;
  }

  var scrollDebug = initEmissionScrollDebug();

  // Lenis 本体が読み込めていない場合は何もしない（保険）
  if (typeof window.Lenis === 'undefined') {
    scrollDebug.log('lenis:missing');
    return;
  }

  // 「視差効果を減らす」設定の利用者には慣性スクロールを適用しない（OS のアクセシビリティ設定を尊重）
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    scrollDebug.log('lenis:reduced-motion-disabled');
    return;
  }

  // 慣性スクロールの本体を生成
  // lerp: 数値が小さいほど「ぬるっと」長く滑り、大きいほど素早く追従する
  // smoothWheel: マウスホイール／トラックパッドでのスムーススクロールを有効化
  // （スマホ等のタッチ操作は標準のままにし、モバイルでの違和感を避ける）
  var lenis = new window.Lenis({
    lerp: 0.1,
    smoothWheel: true,
    wheelMultiplier: 1,
  });

  scrollDebug.log('lenis:init', {
    lerp: 0.1,
    smoothWheel: true,
    wheelMultiplier: 1,
  });

  // 他スクリプトから参照できるよう公開しておく
  window.lenis = lenis;

  // 毎フレーム Lenis に時間を渡してスクロール位置を更新する（アニメーションループ）
  var lastRafTime = null;

  function raf(time) {
    if (scrollDebug.enabled && lastRafTime !== null) {
      var frameDelta = time - lastRafTime;

      if (frameDelta > 45) {
        scrollDebug.log('frame:long', {
          frameDelta: Math.round(frameDelta * 10) / 10,
          lenisScroll: Math.round(lenis.scroll || 0),
          actualScrollY: Math.round(window.scrollY || window.pageYOffset || 0),
        });
      }
    }

    lastRafTime = time;
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  if (typeof lenis.on === 'function') {
    var lastLenisLogTime = 0;

    lenis.on('scroll', function (event) {
      if (!scrollDebug.enabled) {
        return;
      }

      var now = performance.now();

      if (now - lastLenisLogTime < 250) {
        return;
      }

      lastLenisLogTime = now;
      scrollDebug.log('lenis:scroll', {
        scroll: Math.round(event.scroll || 0),
        velocity: Math.round((event.velocity || 0) * 100) / 100,
        direction: event.direction,
        progress: Math.round((event.progress || 0) * 1000) / 1000,
        isScrolling: event.isScrolling,
      });
    });
  } else {
    scrollDebug.log('lenis:on-unavailable');
  }

  if (scrollDebug.enabled) {
    var lastWheelLogTime = 0;

    window.addEventListener(
      'wheel',
      function (event) {
        var now = performance.now();

        if (now - lastWheelLogTime < 200) {
          return;
        }

        lastWheelLogTime = now;

        var newArrivals = document.querySelector('[data-top-new-arrivals-section]');
        var prism = document.querySelector('[data-top-prism-section]');
        var newArrivalsRect = newArrivals ? newArrivals.getBoundingClientRect() : null;
        var prismRect = prism ? prism.getBoundingClientRect() : null;

        scrollDebug.log('input:wheel', {
          deltaY: Math.round(event.deltaY),
          deltaMode: event.deltaMode,
          newArrivalsTop: newArrivalsRect ? Math.round(newArrivalsRect.top) : null,
          newArrivalsBottom: newArrivalsRect ? Math.round(newArrivalsRect.bottom) : null,
          prismTop: prismRect ? Math.round(prismRect.top) : null,
          prismBottom: prismRect ? Math.round(prismRect.bottom) : null,
          lenisScrolling: document.documentElement.classList.contains('lenis-scrolling'),
        });
      },
      { passive: true }
    );
  }

  // ドロワーやモーダル等のオーバーレイ表示中、テーマは <html> に "lock" クラスを付けて
  // 背景ページのスクロールを固定する。その間は慣性スクロールも止め、
  // オーバーレイ内部の通常スクロールを邪魔しないようにする。
  var root = document.documentElement;
  var syncLockState = function () {
    if (root.classList.contains('lock')) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };
  syncLockState();

  new MutationObserver(syncLockState).observe(root, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
